
    // Do not modify this file by hand!
    // Re-generate this file by running lit-localize

    
    

    /* eslint-disable no-irregular-whitespace */
    /* eslint-disable @typescript-eslint/no-explicit-any */

    export const templates = {
      's1488e73779d7682f': `1) ブラウザメニューを開く`,
's182ab2d6c997515f': `ホーム画面に追加して、幅広い体験と簡単なアクセスを実現してください。`,
's1b9047d53d9f9d22': `2) ナビゲーションバーで共有を押す`,
's2d90afa5dcca2c0e': `3) 「ホーム画面に追加」までスクロールする`,
's37a9e8aec5713460': `展開`,
's4593f304dac8848c': `2) 「ホーム画面に追加」をタップする`,
's54cfbb14f46396d4': `1) メインブラウザで開く`,
's6196153c4b0c1ea0': `インストール`,
's922329d6f6213590': `Dockに追加`,
'sa5ef80b4bb9b39f8': `折りたたむ`,
'sa7551383d1897fcc': `2) 「Dockに追加」を押す`,
'sba52286c21552a4e': `デバイスにインストールすることで、より充実した体験と簡単なアクセスを実現できます。`,
'sc79fd7641eb9a975': `説明を非表示`,
'scdaf4bbff76674c8': `ホーム画面に追加`,
'se740f75b95a51807': `ドックに追加して、幅広い体験と簡単なアクセスを実現してください。`,
'sfea652f6580ff086': `このサイトはアプリ機能があります。`,
    };
  